import { IoCopyOutline } from 'react-icons/io5';
import { FiPlus } from 'react-icons/fi';
// import SearchBlock from '../SearchBlock';
import Button from '../Button';
import { ResearchProjectStyle } from './ResearchProject.style';
import ThreadCard from '../ThreadCard';
import ModalContainer from '../ModalContainer';
import AddChatModal from '../AddChatModal';
import projectService from '../../services/projectService';
import { useParams } from 'react-router-dom';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../context/authContext';
import Loaders from '../Loaders';
import { useQuery } from '@tanstack/react-query';

const ResearchProjectBlock = () => {
  const { id } = useParams();
  const { fetch, refetch } = useContextHook(AuthContext, v => ({
    fetch: v.fetch,
    refetch: v.refetch,
  }));

  const { _data, _loading } = projectService.GetProjectSessions(id, fetch);

  return (
    <>
      <ResearchProjectStyle>
        <div className="left-column">
          <div className="header">
            {_loading ? (
              ''
            ) : (
              <>
                <strong className="heading">{_data?.project_name}</strong>
                <p>{_data?.description}</p>
              </>
            )}
          </div>
          <div className="content-area">
            <div className="head">
              <strong className="title">Chat Threads</strong>
              <ModalContainer
                noHead
                width="750"
                title=""
                content={({ onClose }) => <AddChatModal onClose={onClose} refetch={refetch} />}
                btnComponent={({ onClick }) => (
                  <Button width="150px" variant="outline" onClick={onClick}>
                    <FiPlus /> Add Chat
                  </Button>
                )}
              />
            </div>
            <div className="scroll-area">
              {!_loading && _data?.sessions?.length === 0 && (
                <div className="no-threads">
                  <p>
                    Start chatting below to start chatting with this project,
                    <br /> or use the plus button to add existing chats to this project.
                  </p>
                </div>
              )}

              {_loading ? <Loaders viewLoader /> : <ThreadCard threadCardsData={_data?.sessions} refetch={refetch} />}
            </div>
          </div>
          {/* <SearchBlock noMargin /> */}
        </div>
      </ResearchProjectStyle>
    </>
  );
};

export default ResearchProjectBlock;
